// External
import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'reflexbox';

// Internal
import { Header as UIHeader, Logo } from '@iclinic/iclinic-ui';
import HeaderNavigatorLink from 'ui/header/HeaderNavigatorLink';
// Styles
import ss from './Header.scss';

/**
 * Main Application Header
 */
const Header = ({ logout }) => (
  <div className={ss.header}>
    <UIHeader middleChildren={<Logo kind="white" width={25} />}>
      <Flex align="center" justify="left" className={ss.menu_wrapper}>
        <Box ml={10}>
          <ul className={ss.menu}>
            <li>
              <HeaderNavigatorLink to="/app/dashboard/">
                Painel
              </HeaderNavigatorLink>
            </li>
            <li>
              <a
                href="/logout/"
                onClick={(e) => {
                  e.preventDefault();
                  logout();
                }}
              >
                Logout
              </a>
            </li>
          </ul>
        </Box>
      </Flex>
    </UIHeader>
  </div>
);

Header.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default Header;
